// ---------------------------------------------------------------------------
// AppLock — Typed event emitter
// ---------------------------------------------------------------------------
/**
 * Lightweight typed event emitter.
 *
 * - Supports typed events via `AppLockEventMap`
 * - Handlers that throw do not break other listeners
 * - `off` silently ignores unregistered handlers
 */
export class EventBus {
    constructor() {
        this.listeners = new Map();
    }
    /** Register a handler for the given event. */
    on(event, handler) {
        if (!this.listeners.has(event)) {
            this.listeners.set(event, new Set());
        }
        this.listeners.get(event).add(handler);
    }
    /** Remove a previously registered handler. */
    off(event, handler) {
        this.listeners.get(event)?.delete(handler);
    }
    /** Emit an event, calling all registered handlers. */
    emit(event, ...args) {
        const handlers = this.listeners.get(event);
        if (!handlers)
            return;
        for (const handler of handlers) {
            try {
                handler(...args);
            }
            catch (err) {
                // Don't let one handler break the chain
                console.error(`[AppLock] Error in "${event}" handler:`, err);
            }
        }
    }
    /** Remove all handlers for all events. */
    clear() {
        this.listeners.clear();
    }
}
//# sourceMappingURL=event-bus.js.map